import { QUERY_KEY_PREFIXES } from 'dpl/shared/fetching/utils/constants';
import generateQueryKey from 'dpl/shared/fetching/utils/generateQueryKey';

// shared across calls: useResourceQuery returns this object as `value`
// whenever the query has no data, and consumers key effects off value's
// identity -- a fresh object per call would re-fire them every render
const EDIT_PHOTOS_DEFAULT_VALUE = {
  testimonial: {
    photographs_attributes: []
  }
};

export function testimonialQuizEditPhotosDefinition(testimonialId) {
  return {
    url: `/api/testimonials/${testimonialId}/edit_photos.json`,
    defaultValue: EDIT_PHOTOS_DEFAULT_VALUE
  };
}

export function testimonialQuizEditDefinition(testimonialId) {
  return {
    prefix: QUERY_KEY_PREFIXES.TESTIMONIAL,
    url: `/api/testimonials/${testimonialId}/edit.json`,
    defaultValue: {
      testimonial: {}
    }
  };
}

export function testimonialQuizMutationDefinition(testimonialId) {
  return {
    url: `/api/testimonials/${testimonialId}`,
    method: 'PUT',
    // the PUT response mirrors the edit_photos payload (both render the show
    // view), so fold it straight into the cache instead of refetching
    updateStrategy: 'success',
    queryKey: generateQueryKey(
      testimonialQuizEditPhotosDefinition(testimonialId)
    )
  };
}

export function testimonialQuizSubmissionAnswersDefinition(quizSubmissionId) {
  return {
    url: `/api/testimonial_quiz_submission_answers/${quizSubmissionId}`,
    defaultValue: []
  };
}
